import t from "../translations";

export const MIN_IMAGE_SIZE = 80;
export const MAX_IMAGE_SIZE = 400;
export const DEFAULT_IMAGE_SIZE = 160;

export interface CropMeta {
  isAugmented: boolean;
  cropIndex: number | null;
}

export function parseCropFilename(path: string): CropMeta {
  const filename = path.split("/").pop() ?? path;
  const match = filename.match(/_(aug|original)(?:_(\d+))?\.jpe?g$/i);
  const isAugmented = match ? match[1].toLowerCase() === "aug" : false;
  const cropIndex = match?.[2] ? parseInt(match[2], 10) : null;
  return { isAugmented, cropIndex };
}

export function formatCropLabel({ isAugmented, cropIndex }: CropMeta): string {
  const kind = isAugmented ? t.Augmented : t.Original;
  return cropIndex !== null ? `${kind} ${cropIndex}` : kind;
}
